// Centralized environment-driven config.
// CRA bakes REACT_APP_* into the build at build-time — never read process.env
// outside this module so swap-in is one edit.
//
// API_BASE: with SWA Standard linked-backend, frontend calls /api/* are
// proxied to the App Service backend automatically. Default is empty
// (relative). For local dev, the CRA proxy in package.json forwards
// /api/* to localhost:8000. The override via REACT_APP_API_URL is kept
// only for legacy / debug scenarios where someone wants to point a built
// bundle at a different backend host.

export const API_BASE = process.env.REACT_APP_API_URL || '';

export const CLIENT_MODE = process.env.REACT_APP_CLIENT_MODE === 'true';

// Non-prod escape hatch. When REACT_APP_AUTH_DISABLED=true the SPA skips the
// SWA /.auth/me check and runs as a synthetic system_admin — the frontend
// mirror of the backend's ENTRA_AUTH_ENABLED=false kill-switch. Used for the
// -test environment before its SSO app is wired. NEVER set this in a prod build.
export const AUTH_DISABLED = process.env.REACT_APP_AUTH_DISABLED === 'true';

const DEFAULT_TABS = 'dashboard,extraction,records,rules,audit';

export const ENABLED_TABS = new Set(
  (process.env.REACT_APP_ENABLED_TABS || DEFAULT_TABS)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean),
);
